/* Packages */
import React from 'react';
import { createRoot } from 'react-dom/client';

/* utilities */
import { parseDataToProps } from '../../utilities';

const searchNodes = Array.from(document.querySelectorAll('div[data-training-overview]'));
if (searchNodes.length) {
    import(/* webpackChunkName: "EducationPrograms" */ './components/TrainingOverview').then(({ default: TrainingOverview }) => {
        searchNodes.forEach((node) => createRoot(node).render(<TrainingOverview {...parseDataToProps(node.dataset)}/>));
    });
}
